import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import Windowsticker, {
  TemporaryMaterialChoices
} from 'src/app/model/product/windowsticker/windowsticker';
import { Project } from '../../../model/project/project';
import { ProductTypes } from 'src/app/model/product/product-type';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { RequestService } from 'src/app/services/request.service';
import ProductSize from 'src/app/model/product/product-size';
import { FormatDecimal } from 'src/app/pipes/format-decimal';
import PMSColor from 'src/app/model/company/pmscolor';
import { Subject } from 'rxjs';
import Company from 'src/app/model/company/company';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import StandardStickerPart from 'src/app/model/product/windowsticker/standard-sticker-part';
import { ModalService } from 'src/app/services/modal.service';
import { StandardStickerPartDeletedEvent } from 'src/app/events/standard-sticker-part-deleted';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';

@Component({
  selector: 'windowstickerForm',
  templateUrl: './windowsticker.component.html',
  styleUrls: ['./windowsticker.component.scss'],
  providers: [FormatDecimal]
})
export class WindowstickerComponent extends SubscriptionBasedComponent
  implements OnInit {
  temporaryMaterialOptions: any[];
  @Input()
  public inputProject: Project;
  @Input()
  public inputProduct: Windowsticker;
  @Input()
  public involvedCompanies: Company[];
  @Input()
  public pmsColorAdded: Subject<PMSColor>;
  @Input()
  public client = false;
  @Input()
  public fromOldSystem = false;
  @Input()
  public disabled = false;
  @Input()
  public standardStickerPartDeleted: Subject<StandardStickerPartDeletedEvent>;
  @Output()
  public outPutWindowSticker = new EventEmitter<Windowsticker>();

  init = false;

  public inputWindowSticker;
  public allProductSizes: ProductSize[];

  productMaterialChanged = new EventEmitter<any>();
  temporaryMaterialChanged = new EventEmitter<any>();

  constructor(
    private requestService: RequestService,
    private modalService: ModalService,
    private projectDisplayObservableService: ProjectDisplayObservableService,
    public formatDecimal: FormatDecimal
  ) {
    super();
    this.temporaryMaterialOptions = [
      TemporaryMaterialChoices.TEMPORARY,
      TemporaryMaterialChoices.PERMANENT
    ];
  }

  ngOnInit() {
    this.getProductSizes();
    if (!CollectionHelper.isPopulated(this.inputProduct.standardStickerParts)) {
      if (this.inputProduct.standardStickerParts == null) {
        this.inputProduct.standardStickerParts = [new StandardStickerPart()];
      }
      if (this.inputProduct.standardStickerParts.length === 0) {
        this.inputProduct.standardStickerParts.push(new StandardStickerPart());
      }
    }
  }

  getProductSizes() {
    this.addSubscription(
      this.requestService.getNormal('/window_sticker_sizes/unpaged'),
      result => {
        this.allProductSizes = result;
        this.init = true;
      }
    );
  }

  materialTypeUpdate(event) {
    delete this.inputProduct.foil;
    delete this.inputProduct.laminate;
    this.temporaryMaterialChanged.emit();
    this.productMaterialChanged.emit();
    this.outPutWindowSticker.emit();
    this.projectDisplayObservableService
      .getProductMaterialChangedSubscribable()
      .next();
  }

  layoutDescriptionChanged() {
    this.projectDisplayObservableService
      .getStandardStickerPartsChangedSubscribable()
      .next();
    this.outPutWindowSticker.emit();
  }

  addStandardStickerPart() {
    this.inputProduct.standardStickerParts.push(new StandardStickerPart());
    this.projectDisplayObservableService
      .getStandardStickerPartsChangedSubscribable()
      .next();
  }

  deleteStandardStickerPart(index) {
    this.modalService.confirmDialog(
      'Sticker verwijderen',
      'Bent u zeker dat u deze sticker wilt verwijderen?',
      b => {
        if (b) {
          const deleted = this.inputProduct.standardStickerParts.splice(
            index,
            1
          );
          this.outPutWindowSticker.emit();
          if (
            this.standardStickerPartDeleted != null &&
            CollectionHelper.isPopulated(deleted)
          ) {
            this.standardStickerPartDeleted.next({
              sticker: this.inputProduct,
              standardStickerPart: deleted[0]
            });
            this.projectDisplayObservableService
              .getStandardStickerPartsChangedSubscribable()
              .next();
          }
        }
      }
    );
  }

  isWindowSticker(): boolean {
    return this.inputProduct.type === ProductTypes.WINDOWSTICKER.value;
  }
}
